module.exports = __webpack_public_path__ + "img/912.1379e02c.jpeg";